


import React from "react";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image } from "antd";
import { useNavigate,useSearchParams } from "react-router-dom";
import usePost from "../../services/usePost";
import useCustomSnackbar from "../../helper/useCustomSnackbar";

const ChangePassword = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  console.log(token,'......'); 

  const [postLoading, errorMsg, postData] = usePost();
  const showSnackbar = useCustomSnackbar();

  const handleRedirectLogin = () => {
    navigate('/')
  }
  const onFinish = async(values) => {
    // setIsLoggedIn(true);
    // navigate("/dashboard");
    // console.log("Success:", values);

    if(values.newPassword === values.confirmPassword && token){
      const dataToSend = {
        token:token ,
        newPassword: values.newPassword
      }
      try{
        const response = await postData('auth/reset-password',dataToSend)
        if(response){
           setTimeout(() => {
            navigate("/login")
          }, 2000);
  
        }
      }
      catch(err){
        console.log(err)
      }
    }
    else{
      showSnackbar('error','Password doesnt match')
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      <Col md={12}>
        <div className="forgetPass"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <h3>Reset your Password ?</h3>

          <hr className="my-4" />
          {/* <Form.Item
            name="token"
            label="Token"
            rules={[{ required: true, message: "Please input your Token!" }]}
          >
            <Input className="input_field" placeholder="Token" />
          </Form.Item> */}
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true, message: "Please input your New Password!" },
              {
                min: 6,
                message: "Password must be at least 6 characters long!"
              }
            ]}
          >
            <Input className="input_field" placeholder="New Password" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            rules={[
              { required: true, message: "Please input your New Password!" },
              {
                min: 6,
                message: "Password must be at least 6 characters long!"
              }
            ]}
          >
            <Input className="input_field" placeholder="New Password" />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              className="btn_submit"
            >
              Reset
            </Button>
          </Form.Item>
          {/* <Form.Item>
            <Flex justify="center" align="center">
              <p onClick={handleRedirectLogin} style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500' }}>Back to Login</p>
            </Flex>
          </Form.Item> */}
        </Form>
      </Col>
    </Row>
  );
};

export default ChangePassword;
